/**
 * Which kind of page this document is, as its head says. The app bundles the
 * marketing site and the dashboard together, and a module every page loads
 * sometimes has to know which of the two it is serving before React has run,
 * when `useIsDashboard` in `__root.tsx` cannot answer. The root prints this
 * mark in the head of every marketing document, from that same route match.
 */
export const MARKETING_DOCUMENT_META = "webshare-surface";

/** Whether this document is a marketing page. Never on the server. */
export function isMarketingDocument(): boolean {
  return (
    typeof document !== "undefined" &&
    document.querySelector(
      `meta[name="${MARKETING_DOCUMENT_META}"][content="marketing"]`
    ) !== null
  );
}
